import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/system/Unstable_Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { isEmpty, map } from "lodash";
import { useCallback, useMemo, useState } from "react";
import { useQuery } from "react-query";
import { ArtImage } from "../../../components/ArtImage";
import { Autocomplete } from "../../../components/Autocomplete";
import { listFormats, listTemplates } from "../../../services/studio";
import { Format, Template } from "../../../types/studio";
import Button from "@mui/material/Button";
import { RED } from "../../../utils/colors";
import { DeleteOutlineRounded } from "@mui/icons-material";
import { useDialogConfirmation } from "../../../hooks/useDialogConfirmation";

export function MyModels() {
  const dialog = useDialogConfirmation();
  const [selectedFormats, setSelectedFormats] = useState<Format[]>();

  const formatsTemplates = useMemo(() => {
    return selectedFormats?.map((format) => format.id).toString() as string;
  }, [selectedFormats]);

  const formats = useQuery("formats", listFormats);

  const templates = useQuery(["templates", formatsTemplates], () =>
    listTemplates({ formats: formatsTemplates })
  );

  const handleDelete = useCallback(
    (id: number) => {
      dialog.show(
        "Excluir meu modelo?",
        "Tem certeza que deseja excluir este modelo?",
        {
          onConfirmate: () => {
            console.log(id);
            dialog.close();
          },
        }
      );
    },
    [dialog]
  );

  const RenderOverlay = (data: Template) => {
    return (
      <Stack direction="row" justifyContent="flex-end">
        <Button
          onClick={() => {
            handleDelete(data.id);
          }}
          disableElevation
          size="small"
          variant="contained"
          color="inherit"
          sx={{ color: RED, minWidth: 0 }}
        >
          <DeleteOutlineRounded />
        </Button>
      </Stack>
    );
  };

  return (
    <Stack spacing={2}>
      <Stack spacing={2} direction="row" width="20%">
        <Autocomplete
          multiple
          fullWidth
          size="small"
          label="Formatos"
          options={formats.data}
          getOptionLabel={(option) => option.name}
          loading={formats.isLoading}
          value={selectedFormats}
          onChange={(_, formats) => {
            setSelectedFormats(formats);
          }}
        />
      </Stack>
      <Grid container spacing={2}>
        {templates.isLoading ? (
          <Grid xs={12} justifyContent="center" sx={{ display: "flex" }}>
            <CircularProgress />
          </Grid>
        ) : isEmpty(templates.data) ? (
          <Grid xs={12} justifyContent="center" sx={{ display: "flex" }}>
            <Typography color="GrayText">
              Lista de meus modelos vazia.
            </Typography>
          </Grid>
        ) : (
          map(templates.data, (template, index) => (
            <Grid xs={2} key={index}>
              <ArtImage
                overlayComponent={<RenderOverlay {...template} />}
                image={template.imageURL}
                name={template.name}
              />
            </Grid>
          ))
        )}
      </Grid>
    </Stack>
  );
}
